import React from "react"

import { WebsocketContext } from "./WebsocketContext"

const NO_OP = () => {}

/**
 * Stub WebsocketContext for unauthenticated screens.
 * Satisfies the context shape so hooks like useMicrophoneStream can call
 * useWebsocket() without throwing. The cluster is always behind an
 * onInteractionBlocked overlay in unauth views, so nothing here ever runs.
 */
export function UnauthWebsocketProvider({ children }: React.PropsWithChildren) {
  const stubValue = {
    sendMessage: NO_OP,
    readyState: 3, // WebSocket.CLOSED
    sendJsonMessage: NO_OP,
    getWebSocket: () => null,
    connectionStatus: "Closed",
    isConnected: false,
    getIsConnected: () => false,
    error: null,
    setError: NO_OP,
    reconnectAttempts: 0,
    forceReconnect: NO_OP,
  } as any

  return <WebsocketContext.Provider value={stubValue}>{children}</WebsocketContext.Provider>
}
